import { forward } from 'effector';

import { fetchUserFx } from './user.store';
import { authData$ } from './auth.store';

forward({
	from: authData$,
	to: fetchUserFx,
});
